import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useParams} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Container, LinkButton,ValidatePixContainer,Subtile } from './styles';
import Form from '../../../../components/Form';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import Select from '../../../../components/Select';
import useBankList from '../../../../hooks/useBankList';
import { ICompany } from '../../../../entities/Company';
import api from '../../../../services/api';
import pusher from '../../../../services/pusher';
import { AccountsContext as Context } from '../../../../context/AccountsContext';

import Modal from '../../../../components/ModalAdmin';
import ModalSendingData from '../ModalSendingData';
import ModalValidationReject from '../ModalValidationReject';
import ModalWaiting from '../ModalWaiting';
import ModalValidationSuccess from '../ModalValidationSuccess';

import orangeDot from '../../../../assets/orange_dot.svg'
import redDot from '../../../../assets/red_dot.svg'
import greenDot from '../../../../assets/green_dot.svg'

import useToggle from '../../../../hooks/useToggle';
import { ViewBankAccountContext } from '../../../../context/CreateBankAccountContext';
import AlertBox from '../../../../components/AlertBox';
import { stringify } from 'querystring';
interface CompanyProfileProps {
    company: ICompany | undefined;
    sendDataToCompanyDetail?: any;
}

interface BankProps {
    name: string;
    code: string;
}

interface ParamTypes {
    id: string
}

type FormData = {
    company_id: string | undefined;
    bank: string;
    account: string;
    account_digit: string;
    agency: string;
    agency_digit: string;    
};

const CardTED: React.FC<CompanyProfileProps> = ({
    company,
    sendDataToCompanyDetail,
}) => {
    
    const [bank, setBank] = useState<string>('');
    
    const bankList = useBankList();
    
    const [isModalOpen, setIsModalOpen] = useToggle(false);
    const {setViewCard} = useContext(ViewBankAccountContext);

    const params = useParams<ParamTypes>()

    const { register, reset, setValue, handleSubmit, errors } = useForm<FormData>({
        defaultValues:{
            company_id: company?.id_code,
            bank: '',
            account: '',
            account_digit: '',
            agency: '',
            agency_digit: '',
        }
    });

    const [disabledInput, setDisabledInput] = useState(false);
    const [disabledButton, setDisabledButton] = useState(false);

    const [loading, setLoading] = useState<number>(0);
    const [alertType, setAlertType] = useState<string>('warning');    
    const [alertMessage, setAlertMessage] = useState<string>('');    
    const [alertShow, setAlertShow] = useState<boolean>(false);
    const [statusVerify, setStatusVerify] = useState<string>('PENDING');
    const [hashId, setHashId] = useState<string>('');
    const [dataFormTemp, setDataFormTemp] = useState<any>([]);
    const [statusPusher, setStatusPusher] = useState<string>('');
    
    const [showModalSending, setShowModalSending] = useState<boolean>(false);    
    const [showModalValidationSuccess, setShowModalValidationSuccess] = useState<boolean>(false);    
    const [showModalValidationReject, setShowModalValidationReject] = useState<boolean>(false);    
    const [showModalWaiting, setShowModalWaiting] = useState<boolean>(false);
    const [processing, setProcessing] = useState<boolean>(false);
    
    const [th, setTh] = useState<any>(null);

    useEffect(()=>{
        const channel = pusher.subscribe(`validation-pix-${company?.id_code}`);

        channel.bind('change-status', (data:any) => {
            if(data.status && data.bankAccountId){      
                setStatusPusher(data.status);        
            }
        });
        
    },[]);

    useEffect(()=>{    
        if(statusPusher){            
            verifyStatusKey(statusPusher);            
        }
    },[statusPusher]);

    const list = bankList.map((s: BankProps) => {
        return { value: s.code, label: s.code+' - '+s.name };
    });

    useEffect(() => {
        register(
            { name: 'bank' },
            { required: { value: true, message: 'Campo obrigatório' } },
        );
    }, [register]);

    const handleChange = useCallback(
        (e) => {
            setValue('bank', e.value);
            setBank(e.value);
        },
        [setValue],
    );

    useEffect(()=>{
        switch(statusVerify){
            case 'PROCESSING': 
                setAlertType('warning'); 
            break;
            case 'PENDING':
                setAlertType('warning'); 
                setDisabledInput(false); 
                setDisabledButton(false);
            break;
            case 'VERIFIED': 
                setAlertType('success'); 
                clearTimeout(th);
            break;
            case 'REFUSED': 
                setAlertType('danger');
                setProcessing(false); 
                clearTimeout(th);
            break;
            case 'ERROR':
                setAlertType('danger');
                setProcessing(false);                 
            break;
        }
    },[statusVerify]);

    const onSubmit = handleSubmit(async (data: FormData) => {
        
        setProcessing(true);
        setShowModalSending(true);
        setDisabledButton(true);
        setDisabledInput(true);
        await api.post(`/bank-account/verify/account`,{
            ...data,
            company_id: company?.id_code
        })
        .then((response)=>{            
            if(response.data){
                
                setAlertMessage(response.data.message);
                setAlertShow(true);
                
                setHashId(response.data.hashId);
                setStatusVerify(response.data.status);                
                setAlertMessage(`Sua conta está sendo verificada. Isso pode levar algumas horas.` );
                setDataFormTemp(data);

                let thTemp = setTimeout(() => {
                    setShowModalSending(false);
                    setShowModalValidationSuccess(true);
                    //setShowModalWaiting(true);
                }, 10000);
                setTh(thTemp);
            }
        })
        .catch((error) => {  
            setProcessing(false);
            setIsModalOpen();
            setShowModalSending(false);
            setAlertShow(true);                        
            let message = 'Estamos com algumas dificultades técnicas, tente novamente mais tarde!';
            
            if (error.response) {
                if(error.response.data.message){
                    message = error.response.data.message;
                    if(error.response.data.errors){
                        message =  error.response.data.errors[0];
                    }
                }             
            }

            setAlertMessage(message);
            setStatusVerify('ERROR');
            setDisabledButton(false);  
                     
        });
    });

    const verifyStatusKey = (status:string)=>{
        
        let message = '';
        
        setStatusVerify(status);
        
        switch(status){            
            case 'VERIFIED':                    
                setAlertMessage(`Sua conta foi verficada com sucesso.` );
                setAlertShow(true);
                setShowModalSending(false);
                setShowModalValidationSuccess(true);
                break;
            case 'REFUSED':   
                let bankName = '';
                list.map((row)=>{
                    if(row.value === bank){
                        bankName = row.label;
                    }
                });                 

                message = `Sua conta não pôde ser verficada.` ;
                if(dataFormTemp.account && dataFormTemp.account_digit){
                    message = `A conta ${dataFormTemp.account}-${dataFormTemp.account_digit} do Banco ${bankName} não pôde ser verficada.` ;
                }
                message+= ` Por favor, informe uma conta válida ou contate nosso suporte.` ;

                setAlertMessage(message);
                setAlertShow(true);   
                setShowModalSending(false);
                setShowModalValidationReject(true);             
            break;
        }            
        
    }

    const handleCloseAlert = ()=>{
        setAlertShow(false);
    }

    const handleCloseRedirectList = ()=>{   
        window.location.reload();          
    }

    const modalSendingData = (
        <Modal isOpen={showModalSending} onRequestClose={()=>setShowModalSending(false)} closeModal={()=>setShowModalSending(false)} smallWidth={true}>
            <ModalSendingData title={hashId?'Aguardando confirmação...':''}/>
        </Modal>
    );       

    const modalValidationSuccess = (
        <Modal isOpen={showModalValidationSuccess} onRequestClose={handleCloseRedirectList} closeModal={handleCloseRedirectList} smallWidth={true}>
            <ModalValidationSuccess onCancel={handleCloseRedirectList} transferType='TED'/>
        </Modal>        
    );

    const modalValidationReject = (
        <Modal isOpen={showModalValidationReject} onRequestClose={handleCloseRedirectList} closeModal={handleCloseRedirectList} smallWidth={true}>
            <ModalValidationReject onCancel={handleCloseRedirectList} onConfirm={setShowModalValidationReject} transferType='TED' company={company}/>
        </Modal>        
    );

    const modalWaiting = (
        <Modal isOpen={showModalWaiting} onRequestClose={handleCloseRedirectList} closeModal={handleCloseRedirectList} smallWidth={true}>
            <ModalWaiting onConfirm={handleCloseRedirectList} />
        </Modal>            
    );

    return (
        <>
        <Container cardTitle="Recebimentos via TED" loading={loading}>
            <Subtile>
                Ao ativar os recebimentos via TED, seus saques serão remetidos somente em dias úteis e dentro do horário comercial.
            </Subtile>

            <Subtile>
                <strong>Sua conta deve estar associada ao {company?.type==1?'CPF do seu cadastro':'CNPJ da sua empresa'}.</strong>
            </Subtile>        

            {alertShow && 
                <AlertBox type={alertType} message={alertMessage} closeBarOnClick={handleCloseAlert}></AlertBox>
            }

            {modalSendingData}
            {modalValidationSuccess}
            {modalValidationReject}
            {modalWaiting}

            <Form onSubmit={onSubmit}>
                <div className="row">
                    <Select
                        name="bank"
                        className="col-md-6"
                        label="Banco"  
                        value={list.find((v) => v.value === bank)}
                        options={list}
                        onChange={handleChange}                        
                        errorMessage={errors.bank?.message}
                        disabled={disabledInput}
                    />
                </div>
                <div className="row">
                    <Input
                        label="Agência"
                        id="bank-agency"
                        name="agency"
                        mask=""
                        placeholder="Agência"
                        className="col-md-6 col-xs-12"
                        register={register({
                            required: { value: true, message: 'Campo obrigatório' },
                        })}                        
                        errorMessage={errors.agency?.message}
                        disabled={disabledInput}
                    />
                    <Input
                        label="Digito"
                        id="bank-agency-digit"
                        name="agency_digit"
                        mask=""
                        placeholder="Digito"
                        className="col-md-6 col-xs-12"
                        register={register}       
                        disabled={disabledInput}                 
                    />
                </div>
                <div className="row">
                    <Input
                        label="Conta"
                        id="bank-account"
                        name="account"
                        mask=""
                        placeholder="Conta"
                        className="col-md-6 col-xs-12"
                        register={register({
                            required: { value: true, message: 'Campo obrigatório' },
                        })}                        
                        errorMessage={errors.account?.message}
                        disabled={disabledInput}
                    />
                    <Input
                        label="Digito"
                        id="bank-account-digit"
                        name="account_digit"
                        mask=""
                        placeholder="Digito"
                        className="col-md-6 col-xs-12"
                        register={register}     
                        disabled={disabledInput}                   
                    />
                </div>
                <>                
                <ValidatePixContainer>
                    {(statusVerify=='PENDING' || statusVerify=='ERROR') && <p className="status-pix"><img src={orangeDot} alt="Verifique sua chave" />Para confirmar, solicite a verificação</p>}
                    {statusVerify=='PROCESSING' && <p className="status-pix"><img src={orangeDot} alt="Verifique sua chave" />Conta em processo de verificação</p>}
                    {statusVerify=='VERIFIED' && <p className="status-pix"><img src={greenDot} alt="Chave verificada" />Conta verificada</p>}
                    {statusVerify=='REFUSED' && <p className="status-pix"><img src={redDot} alt="Chave inexistente" />Conta não pôde ser verificada</p>}
                    
                    {(statusVerify=='PENDING' ) && 
                        <Button primaryPill type="submit" disabled={disabledButton}>Verificar minha conta </Button>
                    }    
                    {( statusVerify=='REFUSED' || statusVerify=='ERROR') && 
                        <Button primaryPill type="button" onClick={()=>{setStatusVerify('PENDING')}} >Trocar conta</Button>
                    }                    
                </ValidatePixContainer>
                </>
            </Form>
        </Container>
        {!processing && 
            <LinkButton onClick={()=>{setViewCard('PIX')}}>
                <svg width="30" height="30" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1" fill="white">
                    <path d="M63.8668 62.6548C62.2896 62.6582 60.7275 62.3471 59.2706 61.7394C57.8136 61.1318 56.4907 60.2397 55.3784 59.1146L43.1174 46.776C42.6835 46.3582 42.1061 46.125 41.5055 46.125C40.905 46.125 40.3276 46.3582 39.8937 46.776L27.5817 59.1659C26.4691 60.2904 25.1461 61.1821 23.6892 61.7894C22.2323 62.3967 20.6703 62.7076 19.0934 62.7042H16.6562L32.1919 78.3381C34.522 80.6828 37.6822 82 40.9774 82C44.2725 82 47.4327 80.6828 49.7628 78.3381L65.3438 62.6586L63.8668 62.6548Z"/>
                    </mask>
                    <path d="M63.8668 62.6548C62.2896 62.6582 60.7275 62.3471 59.2706 61.7394C57.8136 61.1318 56.4907 60.2397 55.3784 59.1146L43.1174 46.776C42.6835 46.3582 42.1061 46.125 41.5055 46.125C40.905 46.125 40.3276 46.3582 39.8937 46.776L27.5817 59.1659C26.4691 60.2904 25.1461 61.1821 23.6892 61.7894C22.2323 62.3967 20.6703 62.7076 19.0934 62.7042H16.6562L32.1919 78.3381C34.522 80.6828 37.6822 82 40.9774 82C44.2725 82 47.4327 80.6828 49.7628 78.3381L65.3438 62.6586L63.8668 62.6548Z" stroke="#FF6D00" stroke-width="2" mask="url(#path-1-inside-1)"/>
                    <mask id="path-2-inside-2" fill="white">
                    <path d="M19.0934 19.2793C20.6705 19.2759 22.2326 19.5869 23.6896 20.1942C25.1465 20.8016 26.4694 21.6933 27.5817 22.8179L39.8937 35.2039C40.3213 35.6336 40.9011 35.875 41.5055 35.875C42.11 35.875 42.6898 35.6336 43.1174 35.2039L55.3784 22.871C56.4908 21.7465 57.8137 20.8549 59.2706 20.2475C60.7276 19.6402 62.2897 19.3291 63.8668 19.3324H65.3438L49.7628 3.66017C47.4327 1.31659 44.2725 0 40.9774 0C37.6822 0 34.522 1.31659 32.1919 3.66017L16.6562 19.2869L19.0934 19.2793Z"/>
                    </mask>
                    <path d="M19.0934 19.2793C20.6705 19.2759 22.2326 19.5869 23.6896 20.1942C25.1465 20.8016 26.4694 21.6933 27.5817 22.8179L39.8937 35.2039C40.3213 35.6336 40.9011 35.875 41.5055 35.875C42.11 35.875 42.6898 35.6336 43.1174 35.2039L55.3784 22.871C56.4908 21.7465 57.8137 20.8549 59.2706 20.2475C60.7276 19.6402 62.2897 19.3291 63.8668 19.3324H65.3438L49.7628 3.66017C47.4327 1.31659 44.2725 0 40.9774 0C37.6822 0 34.522 1.31659 32.1919 3.66017L16.6562 19.2869L19.0934 19.2793Z" stroke="#FF6D00" stroke-width="2" mask="url(#path-2-inside-2)"/>
                    <mask id="path-3-inside-3" fill="white">
                    <path d="M78.3478 32.1854L68.9061 22.7437C68.6937 22.8315 68.4664 22.8777 68.2366 22.8799H63.9451C61.711 22.8857 59.5694 23.7727 57.9854 25.3481L45.6916 37.6419C45.1438 38.1905 44.493 38.6254 43.7767 38.9217C43.0604 39.2181 42.2926 39.37 41.5174 39.3687C40.7422 39.3698 39.9744 39.2178 39.2581 38.9214C38.5418 38.6251 37.891 38.1903 37.3431 37.6419L24.9982 25.297C23.4142 23.7216 21.2726 22.8347 19.0385 22.8288H13.7598C13.5425 22.8247 13.3278 22.7811 13.1262 22.7002L3.64858 32.1778C1.31242 34.5142 0 37.6828 0 40.9868C0 44.2908 1.31242 47.4594 3.64858 49.7958L13.1262 59.2734C13.3278 59.1925 13.5425 59.1489 13.7598 59.1448H19.0385C21.266 59.1375 23.4013 58.2543 24.9831 56.686L37.328 44.3411C38.4535 43.2687 39.9485 42.6704 41.5032 42.6704C43.0578 42.6704 44.5528 43.2687 45.6783 44.3411L57.9721 56.6349C59.5584 58.2159 61.7056 59.1052 63.9451 59.1088H68.2366C68.4669 59.1102 68.6948 59.1558 68.908 59.2431L78.3478 49.8034C80.6839 47.467 81.9963 44.2983 81.9963 40.9944C81.9963 37.6904 80.6839 34.5217 78.3478 32.1854Z"/>
                    </mask>
                    <path d="M68.9061 22.7437L69.6132 22.0366L69.1411 21.5645L68.5241 21.8195L68.9061 22.7437ZM68.2366 22.8799V23.8799L68.2459 23.8798L68.2366 22.8799ZM63.9451 22.8799V21.8799L63.9425 21.8799L63.9451 22.8799ZM57.9854 25.3481L57.2802 24.6391L57.2783 24.641L57.9854 25.3481ZM45.6916 37.6419L44.9844 36.9348L44.984 36.9353L45.6916 37.6419ZM41.5174 39.3687L41.519 38.3687L41.516 38.3687L41.5174 39.3687ZM37.3431 37.6419L38.0505 36.9351L38.0502 36.9348L37.3431 37.6419ZM24.9982 25.297L25.7053 24.5899L25.7034 24.588L24.9982 25.297ZM19.0385 22.8288L19.0412 21.8288H19.0385V22.8288ZM13.7598 22.8288L13.741 23.8286L13.7504 23.8288H13.7598V22.8288ZM13.1262 22.7002L13.4987 21.7722L12.886 21.5262L12.4191 21.9931L13.1262 22.7002ZM3.64858 32.1778L2.94147 31.4707L2.94144 31.4707L3.64858 32.1778ZM0 40.9868H1H0ZM3.64858 49.7958L2.94144 50.5029L2.94147 50.5029L3.64858 49.7958ZM13.1262 59.2734L12.4191 59.9805L12.8859 60.4473L13.4985 60.2015L13.1262 59.2734ZM13.7598 59.1448V58.1448H13.7503L13.7408 58.145L13.7598 59.1448ZM19.0385 59.1448V60.1448L19.0418 60.1448L19.0385 59.1448ZM24.9831 56.686L25.6872 57.3962L25.6902 57.3931L24.9831 56.686ZM37.328 44.3411L36.6381 43.6172L36.6294 43.6255L36.6209 43.634L37.328 44.3411ZM41.5032 42.6704V41.6704V42.6704ZM45.6783 44.3411L46.3854 43.634L46.3769 43.6255L46.3682 43.6172L45.6783 44.3411ZM57.9721 56.6349L57.265 57.3421L57.2662 57.3432L57.9721 56.6349ZM63.9451 59.1088L63.9434 60.1088H63.9451V59.1088ZM68.2366 59.1088L68.2424 58.1088H68.2366V59.1088ZM68.908 59.2431L68.5288 60.1685L69.1446 60.4208L69.6151 59.9502L68.908 59.2431ZM78.3478 49.8034L79.0549 50.5105L79.0549 50.5104L78.3478 49.8034ZM79.0549 31.4783L69.6132 22.0366L68.199 23.4508L77.6406 32.8925L79.0549 31.4783ZM68.5241 21.8195C68.4299 21.8585 68.3291 21.879 68.2272 21.8799L68.2459 23.8798C68.6037 23.8765 68.9575 23.8045 69.2881 23.6679L68.5241 21.8195ZM68.2366 21.8799H63.9451V23.8799H68.2366V21.8799ZM63.9425 21.8799C61.445 21.8864 59.051 22.8779 57.2802 24.6391L58.6906 26.0571C60.0879 24.6674 61.977 23.885 63.9477 23.8799L63.9425 21.8799ZM57.2783 24.641L44.9844 36.9348L46.3987 38.349L58.6925 26.0552L57.2783 24.641ZM44.984 36.9353C44.5292 37.3907 43.9891 37.7517 43.3944 37.9977L44.159 39.8458C44.997 39.4991 45.7583 38.9903 46.3992 38.3485L44.984 36.9353ZM43.3944 37.9977C42.7998 38.2437 42.1625 38.3698 41.519 38.3687L41.5158 40.3687C42.4227 40.3702 43.3209 40.1925 44.159 39.8458L43.3944 37.9977ZM41.516 38.3687C40.8725 38.3696 40.235 38.2434 39.6404 37.9974L38.8758 39.8455C39.7138 40.1921 40.6119 40.3699 41.5187 40.3687L41.516 38.3687ZM39.6404 37.9974C39.0457 37.7514 38.5054 37.3904 38.0505 36.9351L36.6357 38.3487C37.2766 38.9902 38.0379 39.4988 38.8758 39.8455L39.6404 37.9974ZM38.0502 36.9348L25.7053 24.5899L24.2911 26.0041L36.636 38.349L38.0502 36.9348ZM25.7034 24.588C23.9326 22.8269 21.5386 21.8353 19.0412 21.8288L19.0359 23.8288C21.0066 23.834 22.8957 24.6163 24.293 26.0061L25.7034 24.588ZM19.0385 21.8288H13.7598V23.8288H19.0385V21.8288ZM13.7786 21.829C13.6826 21.8272 13.5878 21.8079 13.4987 21.7722L12.7536 23.6282C13.0679 23.7544 13.4024 23.8223 13.741 23.8286L13.7786 21.829ZM12.4191 21.9931L2.94147 31.4707L4.35568 32.8849L13.8333 23.4073L12.4191 21.9931ZM2.94144 31.4707C0.417767 33.9946 -1 37.4176 -1 40.9868H1C1 37.948 2.20708 35.0337 4.35571 32.8849L2.94144 31.4707ZM-1 40.9868C-1 44.556 0.417768 47.979 2.94144 50.5029L4.35571 49.0887C2.20708 46.9399 1 44.0256 1 40.9868H-1ZM2.94147 50.5029L12.4191 59.9805L13.8333 58.5663L4.35568 49.0887L2.94147 50.5029ZM13.4985 60.2015C13.5877 60.1657 13.6827 60.1464 13.7787 60.1446L13.7408 58.145C13.4024 58.1514 13.0679 58.2193 12.7538 58.3453L13.4985 60.2015ZM13.7598 60.1448H19.0385V58.1448H13.7598V60.1448ZM19.0418 60.1448C21.5319 60.1366 23.9188 59.1493 25.6872 57.3962L24.279 55.9759C22.8837 57.3593 21.0002 58.1383 19.0353 58.1448L19.0418 60.1448ZM25.6902 57.3931L38.0351 45.0482L36.6209 43.634L24.276 55.9789L25.6902 57.3931ZM38.0178 45.0651C38.9574 44.1698 40.2054 43.6704 41.5032 43.6704V41.6704C39.6916 41.6704 37.9496 42.3675 36.6381 43.6172L38.0178 45.0651ZM41.5032 43.6704C42.8009 43.6704 44.049 44.1698 44.9885 45.0651L46.3682 43.6172C45.0567 42.3675 43.3147 41.6704 41.5032 41.6704V43.6704ZM44.9712 45.0482L57.265 57.3421L58.6793 55.9278L46.3854 43.634L44.9712 45.0482ZM57.2662 57.3432C59.0395 59.1106 61.4399 60.1047 63.9434 60.1088L63.9467 58.1088C61.9713 58.1056 60.0773 57.3212 58.6781 55.9267L57.2662 57.3432ZM63.9451 60.1088H68.2366V58.1088H63.9451V60.1088ZM68.2307 60.1088C68.3329 60.1094 68.4342 60.1297 68.5288 60.1685L69.2872 58.3178C68.9555 58.1819 68.6009 58.111 68.2424 58.1089L68.2307 60.1088ZM69.6151 59.9502L79.0549 50.5105L77.6406 49.0963L68.2009 58.536L69.6151 59.9502ZM79.0549 50.5104C81.5786 47.9865 82.9963 44.5635 82.9963 40.9944H80.9963C80.9963 44.0331 79.7893 46.9475 77.6406 49.0963L79.0549 50.5104ZM82.9963 40.9944C82.9963 37.4252 81.5786 34.0022 79.0549 31.4783L77.6406 32.8924C79.7893 35.0413 80.9963 37.9556 80.9963 40.9944H82.9963Z" fill="#FF6D00" mask="url(#path-3-inside-3)"/>
                </svg>

                <span>Quero receber via PIX</span>
            </LinkButton> 
    	}
        </>
    );
};

export default CardTED;
